import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { fetchProductsByCategory } from '../../redux/product/productActions';
import { fetchCategories } from '../../redux/content/contentActions';
import { changeHead } from '../../redux/head/headActions';

import pageConfig from '../../config/page.config';
import { breadcrumbConfig } from '../../config/breadcrumb.config';
import { ABreadCrumb } from '../../components/atoms';
import { MLoader } from '../../components/molecules';
import { OPageTitle, OProducts } from '../../components/organisme';

const mapStateToProps = state => ({
	language: state.head.language,
	products: state.product.result,
	isFetching: state.product.isFetching,
	categories: state.content.category,
});

class RentListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			products: [],
			isFetching: true,
		};
	}
	componentDidMount() {
		const crumbs = this.props.match.url.split('/').filter(item => item !== '');

		this.props.fetchProductsByCategory('rent');
		this.props.fetchCategories(crumbs[0]);
		this.props.changeHead({
			id: pageConfig.rentList.id,
			title: this.props.intl.formatMessage({ id: pageConfig.rentList.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.rentList.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		this.setState({
			products: get(props, 'products', []),
			isFetching: get(props, 'isFetching', false),
		});
	}

	render() {
		const url = this.props.match.url.split('/').filter(item => item !== '');
		const translatedCrumbs = url.slice(0, -1).map(crumb => breadcrumbConfig[crumb][this.props.language]);
		const currentUrl = url.slice(url.length - 1).pop() === 'rent' ? { name: breadcrumbConfig.rent[this.props.language] } :
			this.props.categories.find(category => category.slug === this.props.match.params.slug);
		let content = <MLoader className="article--loader-filters " />;

		if (!this.state.isFetching) {
			content = (
				<article className="layout-body">
					<OProducts href={this.props.match.url} items={this.state.products} />
				</article>
			);
		}

		return (
			<section className="section--breadcrumb">
				<article className="article--breadcrumb">
					<ABreadCrumb
						currentPage={get(currentUrl, 'name', '')}
						parents={translatedCrumbs}
						mappedUrl={url.slice(0, -1)}
					/>
				</article>
				<article className="section-xx-list layout-body--fill">
					<OPageTitle label="RENT.PAGE_DESCRIPTION" />
					{content}
				</article>
			</section >
		);
	}
}

RentListPage.propTypes = {
	changeHead: PropTypes.func.isRequired,
	fetchCategories: PropTypes.func.isRequired,
	fetchProductsByCategory: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	changeHead,
	fetchCategories,
	fetchProductsByCategory,
})(injectIntl(RentListPage)));



// WEBPACK FOOTER //
// ./src/pages/producten/rent-list.page.js